'use strict';

function isValidInputType(cardNumber) {
  return typeof cardNumber === 'string' || cardNumber instanceof String;
}

module.exports = isValidInputType;



//////////////////
// WEBPACK FOOTER
// ./~/credit-card-type/lib/is-valid-input-type.js
// module id = 1062
// module chunks = 1